import QRCodeStyling, { CornerSquareType, DotType, DrawType, ErrorCorrectionLevel, Mode, TypeNumber } from 'qr-code-styling';

const initialize = {
  type: 'svg' as DrawType,
  margin: 2,
  qrOptions: {
    typeNumber: 0 as TypeNumber,
    mode: 'Byte' as Mode,
    errorCorrectionLevel: 'H' as ErrorCorrectionLevel,
  },
  imageOptions: {
    hideBackgroundDots: true,
    imageSize: 0.5,
    margin: 5,
    crossOrigin: 'anonymous',
  },
  dotsOptions: {
    size: 10,
    type: 'extra-rounded' as DotType,
  },
  cornersSquareOptions: {
    type: 'extra-rounded' as CornerSquareType,
  },
};

export const generateQRCode = async (
  value: string,
  options?: {
    logo?: string;
  },
) => {
  const x = {
    ...initialize,
    image: options?.logo || undefined,
    data: value,
  };
  const svg = await new QRCodeStyling(x).getRawData('svg');
  if (!svg) return null;

  let svgString: string;
  if (svg instanceof Blob) {
    svgString = await svg.text();
  } else {
    svgString = svg.toString();
  }

  const base64 = btoa(svgString);
  return `data:image/svg+xml;base64,${base64}`;
};
